<div class="p-6 min-w-96">
  <div class="flex items-start gap-4">
    <div class="flex-1">
      <h2 class="text-xl font-semibold text-gray-900 mb-2">
        {{ data.title || getDefaultTitle() }}
      </h2>

      <p class="text-gray-600 mb-4">
        {{ data.message || getDefaultMessage() }}
      </p>

      @if (data.showDetails && data.details) {
        <mat-expansion-panel class="mb-4 shadow-none border border-gray-200">
          <mat-expansion-panel-header>
            <mat-panel-title class="text-gray-700"> Technische Details </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="space-y-3 text-sm">
            @if (data.details.statusCode) {
              <div><strong>Status:</strong> {{ data.details.statusCode }}</div>
            }
            @if (data.details.message) {
              <div><strong>Message:</strong> {{ data.details.message }}</div>
            }
            @if (data.details.detailsMessage) {
              <div><strong>Details:</strong> {{ data.details.detailsMessage }}</div>
            }
            @if (data.details.path) {
              <div><strong>URL:</strong> {{ data.details.path }}</div>
            }
          </div>
        </mat-expansion-panel>
      }

      <div class="flex justify-end">
        <button
          mat-raised-button
          (click)="onClose()"
          class="bg-primary-500 text-white hover:bg-primary-600"
        >
          Schließen
        </button>
      </div>
    </div>
  </div>
</div>
